/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.IPage<defs.tms.PlatformLogisticsResponseDto>>;
export function request(
  params: API.tms.platformLogistics.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/platformLogistics/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
